import { SUBSCRIPTION_BUTTONV2DETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  payments: [],
  subscriptionDetails: [],
  subscriptionButtonDetailsStatus: undefined,
  subscriptionButtonDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_BUTTONV2DETAILS.FETCH:
      return {
        ...state,
        subscriptionButtonDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case SUBSCRIPTION_BUTTONV2DETAILS.SUCCESS:
      return {
        ...state,
        subscriptionDetails: action.payload,
        subscriptionButtonDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case SUBSCRIPTION_BUTTONV2DETAILS.FAILED:
      return {
        ...state,
        subscriptionButtonDetailsError: action.payload,
        subscriptionButtonDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    case SUBSCRIPTION_BUTTONV2DETAILS.PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.payload,
      };
    default:
      return state;
  }
};
